export default () => ({
    app: {
        CEX_ENVIRONMENT: process.env.REACT_APP_ENV,
        CEX_CAREX_URL: process.env.REACT_APP_CAREX_WEB_UR,
    },
    restServices: {
        CEX_AUTH_RS: process.env.REACT_APP_AUTH_RS_URL,
        CLIENT_ID: process.env.REACT_APP_CLIENT_ID,
    },
});